import { createContext } from "react";

export type ThemeMode = "light" | "dark";

export type ThemeColor =
  | "default"
  | "blue"
  | "green"
  | "rose"
  | "violet"
  | "orange"
  | "yellow"
  | "black";

export type ThemeConfig = {
  mode: ThemeMode;
  color: ThemeColor;
};

export type ThemeProviderProps = {
  children: React.ReactNode;
  defaultTheme?: ThemeConfig;
  storageKey?: string;
  attribute?: string;
  enableSystem?: boolean;
  disableTransitionOnChange?: boolean;
};

type ThemeProviderState = {
  theme: ThemeConfig;
  setTheme: (theme: ThemeConfig) => void;
  setMode: (mode: ThemeMode) => void;
  setColor: (color: ThemeColor) => void;
};

const initialState: ThemeProviderState = {
  theme: { mode: "light", color: "default" },
  setTheme: () => null,
  setMode: () => null,
  setColor: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
